export default "__VITE_ASSET__012986f2__"